import React from 'react';
import { Switch } from 'react-router-dom';
import routes from './routes';
import ProtectedRoute from './components/ProtectedRoute';
import generateParentPath from './helpers/generateParentPath';
import Intl from './i18n/Intl';
import Navbar from './components/Navbar/Navbar';
import FullRedirect from './components/FullRedirect';
import PageViewTracker from './hooks/PageViewTracker';

const App = () => (
  <Intl>
    <div className="app">
      <Navbar />
      <PageViewTracker>
        <Switch>
          {
            Object.entries(routes).map(([name, options]) => {
              const {
                path, exact, component, parent, enter,
              } = options;

              const compiledPath = parent ? generateParentPath(parent, path) : path;
              routes[name].compiledPath = compiledPath;

              return (
                <ProtectedRoute
                  key={name}
                  name={name}
                  path={compiledPath}
                  exact={exact}
                  component={component}
                  enter={enter}
                />
              );
            })
          }
          <FullRedirect to="/" />
        </Switch>
      </PageViewTracker>
    </div>

  </Intl>
);

export default App;
